import { createAction } from '@reduxjs/toolkit';

export const FETCH_ZONES = createAction('surcharge/ZONES');
export const FETCH_METADATA = createAction('surcharge/METADATA');
